// extracted by mini-css-extract-plugin
module.exports = {"workoutWrapper":"workout-module--workoutWrapper--2T5qJ","workoutsTotal":"workout-module--workoutsTotal--2TS4I"};